import { render, staticRenderFns } from "./PanelDropdownNavItem.vue?vue&type=template&id=9fa59b98&"
import script from "./PanelDropdownNavItem.vue?vue&type=script&lang=js&"
export * from "./PanelDropdownNavItem.vue?vue&type=script&lang=js&"
import style0 from "./PanelDropdownNavItem.vue?vue&type=style&index=0&id=9fa59b98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports